<script lang="ts" setup>
  const exampleTitropLink = ref('TITROP#7965')

  const chromeAppInstallExampleImage = new URL('/img/chrome-install-app-hint.png', import.meta.url).href
</script>

<template>
  <div class="space-y-4 text-sm">
    <h2 class="text-lg font-semibold">🔗 Direktverlinkung in Texten</h2>
    <p>Es ist möglich, an verschiedenen Stellen direkt im Text eine Verlinkung zu Leistungsobjekten zu erstellen.</p>
    <p>
      Hierfür muss einfach nur im Text TITROP#ID verwendet werden (z.B. TITROP#7965 =>
      <span v-titrop-html="exampleTitropLink" />
      )
    </p>
    <!----------------------->
    <hr />
    <h2 class="text-lg font-semibold">📱 Titrop als App installieren</h2>

    <p>Du kannst Titrop als App auf deinem Gerät installieren, damit du es schneller starten und wie eine echte App verwenden kannst – ohne Browserleiste oder Tabs.</p>

    <div class="border-l-4 border-blue-500 bg-blue-50 dark:border-blue-300 dark:bg-blue-500 p-3">
      <h3 class="font-semibold text-blue-700 dark:text-blue-200">💻 Auf dem Desktop (Chrome oder Edge)</h3>
      <div class="flex flex-col md:flex-row gap-x-4">
        <ol class="list-decimal list-inside">
          <li>
            Achte auf das Symbol
            <strong>🖥️⬇️</strong>
            (Monitor mit Pfeil) ganz rechts in der Adresszeile.
          </li>

          <li>
            Wähle
            <strong>„Titrop installieren“</strong>
            oder
            <strong>„App installieren“</strong>
            .
          </li>
          <li>Bestätige den Dialog.</li>
        </ol>
        <img
          :src="chromeAppInstallExampleImage"
          class="rounded-md" />
      </div>
    </div>

    <div class="border-l-4 border-green-500 bg-green-50 dark:bg-green-900 dark:border-green-300 p-3">
      <h3 class="font-semibold text-green-700 dark:text-green-200">📱 Auf Android (Chrome)</h3>
      <ol class="list-decimal list-inside">
        <li>Tippe auf die drei Punkte oben rechts im Browser-Menü (⋮).</li>
        <li>
          Wähle
          <strong>„App installieren“ oder „Zu Startbildschirm hinzufügen“</strong>
          .
        </li>
        <li>Bestätige die Installation.</li>
      </ol>
    </div>

    <p class="text-xs text-gray-500">Nach der Installation findest du Titrop wie gewohnt auf dem Startbildschirm (Mobil) oder im Startmenü (Desktop).</p>
    <!----------------------->
  </div>
</template>
